const ROLES = [null,
    { role: "admin", landingUrl: "/admin", name: "Admin" },
    { role: "mm_volunteer", landingUrl: "/volunteer", name: "Volunteer" },
    { role: "bat_user", landingUrl: "/dashboard", name: "User" },
    { role: "mm_user", landingUrl: "/dashboard", name: "User" }
]

const rasi = [
    {
        id: 1,
        name: "Mesham"
    },
    {
        id: 2,
        name: "Vrushabam"
    },
    {
        id: 3,
        name: "Mithunam"
    },
    {
        id: 4,
        name: "Karkatam"
    },
    {
        id: 5,
        name: "Simham"
    },
    {
        id: 6,
        name: "Kanya"
    },
    {
        id: 7,
        name: "Tula"
    },
    {
        id: 8,
        name: "Vrushchikam"
    },
    {
        id: 9,
        name: "Dhanussu"
    },
    {
        id: 10,
        name: "Makaram"
    },
    {
        id: 11,
        name: "Kumbham"
    },
    {
        id: 12,
        name: "Meenam"
    }
]


const natchatra = [
    { id: 1, name: "Ashwini" },
    { id: 2, name: "Bharani" },
    { id: 3, name: "Krittika" },
    { id: 4, name: "Rohini" },
    { id: 5, name: "Mrigashira" },
    { id: 6, name: "Ardra" },
    { id: 7, name: "Punarvasu" },
    { id: 8, name: "Pushya" },
    { id: 9, name: "Ashlesha" },
    { id: 10, name: "Magha" },
    { id: 11, name: "Purva Phalguni" },
    { id: 12, name: "Uttara Phalguni" },
    { id: 13, name: "Hasta" },
    { id: 14, name: "Chitra" },
    { id: 15, name: "Swati" },
    { id: 16, name: "Vishakha" },
    { id: 17, name: "Anuradha" },
    { id: 18, name: "Jyeshtha" },
    { id: 19, name: "Mula" },
    { id: 20, name: "Purva Ashadha" },
    { id: 21, name: "Uttara Ashadha" },
    { id: 22, name: "Shravana" },
    { id: 23, name: "Dhanishta" },
    { id: 24, name: "Shatabhisha" },
    { id: 25, name: "Purva Bhadrapada" },
    { id: 26, name: "Uttara Bhadrapada" },
    { id: 27, name: "Revati" }
]
export default ROLES